/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from 'clsx';
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Link, NavLink } from "react-router-dom";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { SupplierPaymentsTable } from "./SupplierPaymentsTable";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { useEventListener } from "../../../../../helpers/useEventListener";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const SupplierPayments = (props) => {

    const { supplierPaymentDetails, loader } = useSelector(state => state.purchaseManagementReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);

    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Supplier Payment', history, 'Purchase')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            history.push('/purchase/purchase-management/supplier-payment/create');
        }
    };
    useEventListener("keydown", handleKeyDown);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ paymentAmount: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ paymentStatus: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'supplierPayment',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.SUPPLIER_PAYMNET_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'supplierPayment',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props}
                closeLink={'/purchase'}
                img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supplier Payments', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Supplier Payments'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Payment ID, Amount and Status'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'supplierPayment', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'supplierPayment', 'Link')}
                                                    onClick={() => { loadImportExportData('SupplierPayment'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'supplierPayment', 'Link')}
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Supplier Payment', 'create', 'Purchase') &&
                                                <Link
                                                    id={idNamingConversion('Make Payment', 'supplierPayment', 'Link')}
                                                    to={"/purchase/purchase-management/supplier-payment/create"}
                                                    // onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Make Payment</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <SupplierPaymentsTable
                                search={search}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'SupplierPayment'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={supplierPaymentDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}

export default SupplierPayments